import { api_resume_paused_subscription_path } from '@routes';

import request from './request';

export interface PauseSubscriptionResponse {
  success: boolean;
}

export async function resumeSubscription(): Promise<PauseSubscriptionResponse> {
  const resp = await request('post', api_resume_paused_subscription_path());
  return resp;
}
